import React, { useState } from "react";
import "./Plans.css";
import LightRays from "./LightRays";

export default function Plans() {
  const [activeFAQ, setActiveFAQ] = useState(null);

  const toggleFAQ = (index) => {
    setActiveFAQ(activeFAQ === index ? null : index);
  };

  return (
    <section className="plans-section" id="plans">
      <LightRays/>
      <h2 className="plans-title">Elige Tu Plan</h2>
      <p className="plans-subtitle">Planes a la medida para adaptarse a tus necesidades</p>

      <div className="plans-grid">
        <div className="plan-card">
          <h3>Plan Basico</h3>
          <p className="price">$100</p>
          <p>Ideal para artistas que buscan una portada profesional con entrega rapida. </p>
          <ul>
            <li>✔ Arte de alta calidad</li>
            <li>✔ Version optimizada para Stories</li>
            <li>✔ Entrega en JPG/PNG</li>
            <li>✔ Atencion Prioritaria</li>
          </ul>
          <button className="featured-btn"
  onClick={() => window.open(
      "https://wa.me/584129034967?text=" +
        encodeURIComponent("Hola, Estoy interesado en el Plan Básico"),
      "_blank"
    )}
>
  Elegir Plan
</button>
        </div>

        <div className="plan-card featured">
          <h3>Plan Pro <br/> <span className="tag">Mas Popular</span></h3>
          <p className="price">$150</p>
          <ul>
            <li>✔ Todo lo del Plan Basico +</li>
            <li>✔  Estilo avanzado (Letra 3D / Montaje)</li>
            <li>✔ Materiales para Pre-Save & OutNow (Instagram / TikTok / Canva)</li>
            <li>✔ Atencion Prioritaria</li>
          </ul>
          <button className="featured-btn"
            onClick={() => window.open(
      "https://wa.me/584129034967?text=" +
        encodeURIComponent("Hola, Estoy interesado en el Plan Pro"),
      "_blank"
    )}
          >
             Elegir Plan
              </button>
        </div>

        <div className="plan-card">
          <h3>Plan Deluxe</h3>
          <p className="price">$230</p>
          <ul>
            <li>✔ Todo lo del Plan Pro +</li>
            <li>✔ Montaje Premium + Vizualizer</li>
            <li>✔ Miniatura optimizada para Youtube</li>
            <li>✔ Atencion Prioritaria</li>
          </ul>
          <button className="featured-btn"
  onClick={() => window.open(
      "https://wa.me/584129034967?text=" +
        encodeURIComponent("Hola, estoy interesado en el plan deluxe"),
      "_blank"
    )}
>
  Elegir Plan
</button>
        </div>
      </div>

      <h3 className="extras-title">Potencia tu Plan con Nuestros Extras</h3>
      <div className="extras-grid">
        <div className="extra-card">
         
          <h4>Version adicional <br/> de la portada</h4>
          <p className="price">$40</p>
        </div>

        <div className="extra-card">
          
          <h4>Banner para <br /> Youtube / spotify <br /> canvas</h4>
           <p className="price">$60</p>
        </div>

        <div className="extra-card">
          
          <h4>Visualizer</h4>
           <p className="price">$150 <br /> (Si solo necesitas el video sin el plan Deluxe)</p>
        </div>
      </div>

      <h3 className="faq-title">Preguntas Frecuentes</h3>
<div className="faq-container">
  {[
    { 
      q: "Métodos de Pago", 
      a: `Acepto pagos vía: <span class='highlight'>Paypal</span> / <span class='highlight'>Zelle</span> / <span class='highlight'>Binance</span> / <span class='highlight'>ATH Móvil</span>.` 
    },
    { 
      q: "¿Cómo Funciona el Proceso?", 
      a: `
      <strong>1️⃣ <span class='highlight'>Hablamos de tu idea:</span></strong> Me cuentas el concepto y la vibra de tu tema.<br><br>
      <strong>2️⃣ <span class='highlight'>Acuerdo y Pago:</span></strong> Pago adelantado o 50% para iniciar el proyecto.<br><br>
      <strong>3️⃣ <span class='highlight'>Proceso de Diseño:</span></strong> Te entrego un boceto y podrás realizar hasta 2 revisiones.<br><br>
      <strong>4️⃣ <span class='highlight'>Entrega Final:</span></strong> Una vez aprobado, se realiza el pago restante y te envío los archivos finales.
      `
    },
    { 
      q: "¿Quién Soy?",  
      a: `
      <strong><span class='highlight'>GlackStudios</span></strong> es un proyecto de arte visual fundado en 
      <span class='highlight'>mayo de 2020</span> en Guayana, Venezuela.<br><br>
      Con <span class='highlight'>21 años</span>, me especializo en la dirección y creación de arte visual, ofreciendo 
      <span class='highlight'>portadas</span> y <span class='highlight'>branding de alta calidad</span> para artistas.<br><br>
      Mi misión es transformar ideas en <span class='highlight'>imágenes impactantes</span> que ayuden a la música a <span class='highlight'>destacar</span> a nivel global.
      `
    },
  ].map((faq, index) => (
    <div
      key={index}
      className={`faq-item ${activeFAQ === index ? "active" : ""}`}
      onClick={() => toggleFAQ(index)}
    >
      <div className="faq-question">
        {faq.q}
        <span>{activeFAQ === index ? "−" : "+"}</span>
      </div>

      {activeFAQ === index && (
        <div
          className="faq-answer"
          dangerouslySetInnerHTML={{ __html: faq.a }}
        ></div>
      )}
    </div>
  ))}
</div>

    </section>
  );
}
